module.exports = __webpack_public_path__ + "img/unison.f37bc504.svg";